import Heading from "./heading";
import Text from "./text";
import Image from "./image";

const ComponentConfigurations = [
  Heading,
  Text,
  Image
];

export default ComponentConfigurations;